import { checkPermissions } from "@elit-hair/elit-tools";
import { Divider, IconButton } from "@mui/material";
import { TbSearch } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import useAuth from "@/providers/hooks/useAuth";
import { useMetasActions } from "@/stores/use-metas";

import GlobalSearchDialog from "./GlobalSearchDialog";

function GlobalSearch() {
    const { userData } = useAuth();
    const { setShowGlobalSearch } = useMetasActions();
    if (!checkPermissions(userData?.permissionCodes, [PERMISSIONS.TR_SVC_PASSENGERS_LIST_BY_DATE])) return null;
    return (
        <>
            <IconButton
                onClick={() => setShowGlobalSearch(true)}
                id="notifications"
                color="inherit"
                className="!shrink-0 !grow-0"
            >
                <TbSearch className="opacity-50 hover:opacity-75" />
            </IconButton>
            <Divider orientation="vertical" className="bg-slate-500 !h-3/4 "></Divider>
            <GlobalSearchDialog />
        </>
    );
}

export default GlobalSearch;
